import GLightbox from "glightbox";
import $ from "jquery";
export default class LightBox {
    static mount() {
        $(function () {
            new LightBox();
        });
    }
    constructor() {
        const customLightboxHTML = `
    <div id="glightbox-body" class="glightbox-container">
      <div class="gloader visible"></div>
      <div class="goverlay"></div>
      <div class="gcontainer">
        <div id="glightbox-slider" class="gslider"></div>
        <button class="gnext gbtn" tabindex="0" aria-label="Next">
          <svg width="31" height="51" viewBox="0 0 31 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.99922 1.51172C2.16713 1.82846 30.1992 24.6625 30.1992 24.6625L2.17121 48.5117" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="gprev gbtn" tabindex="1" aria-label="Previous">
          <svg width="30" height="51" viewBox="0 0 30 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.2 2.46094C28.0321 2.77768 -1.43847e-09 25.6117 -1.43847e-09 25.6117L28.028 49.4609" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="gclose gbtn" tabindex="2" aria-label="Close">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.44929 22.0469L21.5412 2.95499" stroke="#ffffff" stroke-width="3" stroke-linecap="square"/>
            <path d="M2.44922 2.9532L21.5411 22.0451" stroke="#ffffff" stroke-width="3" stroke-linecap="square"/>
          </svg>
        </button>
      </div>
    </div>`;
        const lightbox = GLightbox({
            lightboxHTML: customLightboxHTML,
            touchNavigation: true,
            loop: true,
            moreLength: 0
        });
    }
}
